import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { createFileRoute } from '@tanstack/react-router';
import { ParcelMapView } from '../features/parcel-map/ParcelMapView';

function ParcelMapPage() {
  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
      <Typography variant="h5" sx={{ mb: 1 }}>
        Parcel map
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        A flat US map of our parcel holdings. Zoomed out it shades coverage by state, then county;
        zoom in to street level to see individual parcel footprints, and click one for its detail.
      </Typography>
      <Paper sx={{ p: 2 }}>
        <ParcelMapView />
      </Paper>
    </Box>
  );
}

export const Route = createFileRoute('/parcel-map')({ component: ParcelMapPage });
